import { sendAnalyticsError, sendAnalyticsInfo } from './sendAnalytics';

/**
 * Dispatches analytics info or error for AnswerTO SDP status.
 * @param dispatch Redux dispatch
 * @param sdpReceived Whether SDP was received
 */
export function logAnswerToSdpStatus(dispatch: any, sdpReceived: boolean) {
  if (sdpReceived) {
    dispatch(
      sendAnalyticsInfo({
        Method: 'AnswerTO_SDP_Status',
        Message: 'SDP was received in AnswerTO case',
        LogGroup: 'SIP',
        SdpReceived: true,
      })
    );
  } else {
    dispatch(
      sendAnalyticsError({
        Method: 'AnswerTO_SDP_Status',
        Message: 'SDP was not received in AnswerTO case',
        LogGroup: 'SIP',
        SdpReceived: false,
      })
    );
  }
}
